import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0885fc25&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0885fc25&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885fc25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0885fc25')) {
      api.createRecord('0885fc25', component.options)
    } else {
      api.reload('0885fc25', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0885fc25&scoped=true", function () {
      api.rerender('0885fc25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/dictionary/index.vue"
export default component.exports